export default __webpack_public_path__ + "static/media/ncar.3557810d.png";